var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app page-qrcode flex-row align-items-center" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-md-5 col-lg-4" },
            [
              _vm.enterOTP
                ? _c(
                    "b-modal",
                    {
                      attrs: {
                        title: "Enter Authentication Code",
                        size: "md",
                        "hide-footer": "",
                        "no-close-on-backdrop": "",
                        "no-close-on-esc": "",
                        centered: "",
                      },
                      on: { hide: _vm.close },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "modal-header",
                            fn: function ({ titleClass }) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center w-100",
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-lock text-primary mr-2 fa-lg",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h5",
                                      {
                                        staticClass: "mb-0",
                                        class: titleClass,
                                      },
                                      [
                                        _vm._v(
                                          "\n                Enter Authentication Code\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1653381587
                      ),
                      model: {
                        value: _vm.enterOTP,
                        callback: function ($$v) {
                          _vm.enterOTP = $$v
                        },
                        expression: "enterOTP",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center mb-4" }, [
                        _c("div", { staticClass: "user-info mb-3" }, [
                          _c("div", { staticClass: "bg-light rounded p-3" }, [
                            _c("i", {
                              staticClass: "fa fa-user text-muted mr-2",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-muted" }, [
                              _vm._v("Authenticating as:"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-1" }, [
                              _c("strong", { staticClass: "text-dark" }, [
                                _vm._v(_vm._s(_vm.username)),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "mb-0 text-muted" }, [
                          _vm._v(
                            "\n              Enter the 6-digit code from your authenticator app\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.checkCreds.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "otp-input-section mb-4" },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("b-form-input", {
                                    ref: "otpInput",
                                    staticClass:
                                      "form-control-lg text-center font-weight-bold",
                                    class: { "is-invalid": _vm.errorOTP },
                                    attrs: {
                                      type: "tel",
                                      inputmode: "numeric",
                                      pattern: "[0-9]*",
                                      maxlength: "6",
                                      required: "",
                                      autofocus: "",
                                      placeholder: "000000",
                                      autocomplete: "one-time-code",
                                    },
                                    on: {
                                      input: _vm.handleInput,
                                      paste: _vm.handlePaste,
                                    },
                                    model: {
                                      value: _vm.otp,
                                      callback: function ($$v) {
                                        _vm.otp = $$v
                                      },
                                      expression: "otp",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "mt-2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "progress",
                                        staticStyle: { height: "4px" },
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "progress-bar",
                                          class: _vm.progressClass,
                                          style: {
                                            width: _vm.progressWidth + "%",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.errorOTP
                                ? _c(
                                    "b-alert",
                                    {
                                      staticClass: "mb-0",
                                      attrs: { show: "", variant: "danger" },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-exclamation-triangle mr-2",
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errorOTP) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-between align-items-center",
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "outline-secondary" },
                                  on: { click: _vm.close },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-arrow-left mr-1",
                                  }),
                                  _vm._v(" Back\n              "),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "text-center" }, [
                                _c(
                                  "small",
                                  { staticClass: "text-muted d-block mb-2" },
                                  [
                                    _vm._v(
                                      "\n                  Code auto-submits when complete\n                "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    type: "submit",
                                    variant: "primary",
                                    disabled: _vm.otp.length < 6,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-sign-in mr-1",
                                  }),
                                  _vm._v(" Verify\n              "),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "login-footer" }, [
      _c("img", {
        staticClass: "labs-logo login center-block",
        attrs: { src: "static/img/labs_logo.svg", alt: "labs-img" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }